export const getRankingDisplay = (rank, lovePoints) => {
  if (lovePoints === 0) {
    return '圏外'
  }
  if (rank > 99) {
    return '圏外'
  } else {
    return '現在'
  }
}
